<template>
    <v-col cols="12" class="text-center noprint">
    <v-stepper v-model="localNext">
        <v-stepper-content step="1">
        <v-card
            color="#fefefe"
            class="mb-12"
            elevation="0"
        >
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Teacher Name"
                            outlined dense clearable
                            v-model="record.teacher_name"
                            hint="Once entered, we will save and remember it for you!"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Class"
                            outlined dense clearable
                            v-model="record.class_name"
                            hint="Type the class you are preparing this plan/note for!"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Week"
                            outlined dense clearable
                            v-model="record.week"
                            hint="Just enter a number like Week 7, just type 7"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Subject *"
                            outlined dense clearable
                            v-model="record.subject"
                            hint="If you do not enter a SUBJECT the form wont save!"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-btn
            color="primary"
            @click="storeProgress"
        >
            Next
        </v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">
        <v-card
            color="#fefefe"
            class="mb-12"
            elevation="0"
        >
            <v-card-text>
                <v-row>
                    <v-col>
                        <p>Lesson Plan/Note by: <strong>{{record.teacher_name}}</strong>, for Class <strong>{{record.class_name}}</strong></p>
                        <p>Subject: <strong>{{record.subject}}</strong>, Week <strong>{{record.week}}</strong></p>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Topic *"
                            outlined dense clearable
                            v-model="record.topic"
                            hint="If you do not enter a TOPIC the form wont save!"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            label="Sub-topic"
                            outlined dense clearable
                            v-model="record.subtopic"
                            hint="This is optional and can be skipped"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                            label="Reference Material"
                            outlined dense clearable
                            v-model="record.reference_material"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                            label="Instructional Material"
                            outlined dense clearable
                            v-model="record.instructional_material"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-btn
            color="primary"
            @click="storeProgress"
        >
            Next
        </v-btn>
        <v-btn text @click="localNext = 1">
            Back
        </v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
        <v-card
            color="#fefefe"
            class="mb-12"
            elevation="0"
        >
            <v-card-text>
                <v-row>
                    <v-col>
                        <p>Lesson Plan/Note by: <strong>{{record.teacher_name}}</strong>, for Class <strong>{{record.class_name}}</strong></p>
                        <p>Subject: <strong>{{record.subject}}</strong>, Week <strong>{{record.week}}</strong>, Topic <strong>{{record.topic}}</strong></p>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-textarea
                            label="Objectives"
                            outlined dense clearable
                            v-model="record.objectives"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                            label="Instructions"
                            outlined dense clearable
                            v-model="record.instructions"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                            label="Lesson Content"
                            outlined dense clearable
                            hint="Enter lesson content here if you need lesson note together with lesson plan"
                            v-model="record.lesson_content"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                            label="Body of Topic"
                            outlined dense clearable
                            v-model="record.topic_body"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-file-input
                            counter
                            show-size chip
                            truncate-length="50"
                            placeholder="Click to select one or more images"
                            accept="image/png, image/jpeg, image/jpg"
                            v-model="record.files"
                        ></v-file-input>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-btn
            color="primary"
            @click="storeProgress"
        >
            Next
        </v-btn>
        <v-btn text @click="localNext = 2">
            Back
        </v-btn>
        </v-stepper-content>

        <v-stepper-content step="4">
        <v-card
            color="#fefefe"
            class="mb-12"
            elevation="0"
        >
            <v-card-text>
                <v-row>
                    <v-col>
                        <p>Lesson Plan/Note by: <strong>{{record.teacher_name}}</strong>, for Class <strong>{{record.class_name}}</strong></p>
                        <p>Subject: <strong>{{record.subject}}</strong>, Week <strong>{{record.week}}</strong>, Topic <strong>{{record.topic}}</strong></p>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-textarea
                            label="Evaluation"
                            outlined dense clearable
                            v-model="record.evaluation"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                            label="Questions"
                            outlined dense clearable
                            v-model="record.questions"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-textarea
                            label="Conclusion"
                            outlined dense clearable
                            v-model="record.conclusion"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-btn
            color="primary"
            @click="updatetoArray"
            v-if="editing"
        >
            Update &amp; Preview
        </v-btn>
        <v-btn
            color="primary"
            @click="storetoArray"
            v-else
        >
            Save &amp; Preview
        </v-btn>
        <v-btn text @click="localNext = 3">
            Back
        </v-btn>
        </v-stepper-content>
    </v-stepper>
</v-col>
</template>

<script>
export default {
    name: 'CreateForm',
    props:[
        'records',
        'record',
        'next',
        'editing'
    ],
    data: () => ({
        localNext: 1,
    }),
    methods:{
        generateUniqueId() {
            return Math.random();
        },
        storeProgress(){
            //console.log(this.localNext)
            localStorage.mys_tcpl_record =  JSON.stringify(this.record)
            this.localNext = this.localNext > this.next ? this.localNext + 1 : this.next + 1
        },
        storetoArray(){
            this.fetchImage()
            this.record.id = this.generateUniqueId()
            localStorage.mys_tcpl_record =  JSON.stringify(this.record)
            if(this.record.topic && this.record.subject){
                this.records.push(this.record)
                localStorage.mys_tcpl_records = JSON.stringify(this.records)
                this.viewPreview(this.record)
            }
        },
        updatetoArray(){
            this.fetchImage()
            localStorage.mys_tcpl_record =  JSON.stringify(this.record)
            if(this.record.topic && this.record.subject){
                localStorage.mys_tcpl_records = JSON.stringify(this.records)
                this.viewPreview(this.record)
            }
        },
        fetchImage(){
            if (this.record.files) {
                this.record.files = URL.createObjectURL(this.record.files)
            }
        }

    }
}
</script>
